module.exports = __webpack_public_path__ + "img/pandeaming_logos.9dbfea15.svg";